import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import Binnacles from "../../components/binnacles";
import * as binnacleActions from "../../actions/binnacles";
import { getRoles } from "../../actions/roles";
import { QueryArguments } from "../../../types-business/QueryArguments";

interface Props {
  getBinnacleByPartner: (params?: QueryArguments) => any;
  getModules: () => any;
  getRoles: () => any;
  modules: string[];
  loadingModules: boolean;
  roles: object[];
}

class BinnaclesPage extends React.Component<Props, void> {
  componentDidMount() {
    this.props.getModules();
    this.props.getRoles();
  }

  render() {
    return (
      <main>
        <Helmet title="Bitácora" />
        <Layout headerLabel="Bitácora del Sistema">
          <Binnacles
            getBinnacleByPartner={this.props.getBinnacleByPartner}
            modules={this.props.modules || []}
            loadingModules={this.props.loadingModules}
            roles={this.props.roles || []}
            generateCSVByPartner={binnacleActions.generateCSVByPartner}
          />
        </Layout>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getBinnacleByPartner: (args?: QueryArguments) => {
    return dispatch(binnacleActions.getBinnacleByPartner(args));
  },
  getModules: () => {
    return dispatch(binnacleActions.getModules());
  },
  getRoles: () => {
    return dispatch(getRoles({ size: 500, page: 0 }));
  }
});

const mapStateToProps = state => {
  const { binnacles = {}, role = {} } = state;
  return {
    binnacles: binnacles.binnaclePartner || { data: [], totalPages: 0 },
    modules: Array.isArray(binnacles.modules) ? binnacles.modules : [],
    loadingModules: !!binnacles.loadingModules,
    roles: role.roles && role.roles.content ? role.roles.content : []
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BinnaclesPage);
